import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DynamicCrudService } from 'src/app/___LOGIC/__crud/dynamic-crud.service';

@Component({
  selector: 'app-dynamic-crud-form',
  templateUrl: './dynamic-crud-form.component.html',
  styleUrls: ['./dynamic-crud-form.component.css']
})
export class DynamicCrudFormComponent implements OnInit {

  @Input() config;
  @Output() public dataOut = new EventEmitter();

  form: FormGroup;
  showDebugCard = false;
  formData;
  dynamicFormRes: {status: string; lastOp: string; } = {
    status: '',
    lastOp: ''
  };

  constructor(private fb: FormBuilder,private dynamicCrudService: DynamicCrudService) {
    this.form = this.fb.group({});
  }

  ngOnInit(): void {
    this.createFormControls();
  }

  createFormControls(): void {
    this.config.props.forEach((field) => {
      this.form.addControl(field.columnName, new FormControl(field.value || ''));
    });
  }

  getTableName(columnName){
    return columnName.substring(6);
  }

  getFieldType(field): string {
    switch (field.dataType) {
      case 'int':
        if (field.columnName.substring(0, 5) === 'FK_ID'){
          return 'select';
        }else{
          return 'number';
        }
      case 'float':
        return 'number';
      case 'tinyint':
        return 'boolean';
      case 'date':
        return 'date';
      case 'varchar':
        return 'varchar';
      case 'timestamp':
        return 'timestamp';
      default:
        return 'text';
    }
  }

  isCurrentStatus(status){
    return this.dynamicCrudService.isCurrentStatus(status);
  }

  setCurrentStatus(s){
    this.dynamicCrudService.setCurrentStatus(s);
  }

  getCurrentStatus(){
    return this.config.currentStatus;
  }

  onSubmit(): void {
    console.log(this.form.value);
  }

  addNewRow(){
    /* this.crudFieldsData.setCurrentStatus('create',this.crudConfig.id); */
    this.config.currentStatus = 'create';
  }

  onSelection(event){
    debugger
  }

  updateFormField(field){
  }

  saveChanges(){
    debugger
  }

  create(){
    this.dynamicCrudService.setLoading(true);
    this.dynamicCrudService.createObject(this.config.props,'answer').subscribe(
      (response) => {
        this.dynamicCrudService.setLoading(false);
        this.dynamicFormRes.status = 'ok';
        this.dynamicFormRes.lastOp = 'create';
        this.dataOut.emit(this.dynamicFormRes);
        console.log('Item created:', response);
        //this.loadData(); // Refresh the list after success
      },
      (error) => {
        this.dynamicCrudService.setLoading(false);
        console.error('Error creating item:', error);
      },
      () => {
        this.dynamicCrudService.setLoading(true);
      }
    );
    
    
  }

  isFormValid(){
    /* return this.dynamicCrudService.validForm(this.config.props); */
    return true;
  }

  getCurrentObjectAsString(){
    return JSON.stringify(this.config.props);
  }

  getLastInsertedObjectAsString(){
    return 'TEST';
  }

  getCurrentStatusAsString(){
    return this.config.currentStatus;
  }

  isLoading(){
    return this.dynamicCrudService.isLoading();
  }
}
